import { yieldForBridgeInteractivePriority } from '../../../files/browser/in-flight.js';
import { withCodeNavCacheSqlite } from '../../../sqlite/code-nav-cache/database.js';
import { expandStarReexportForFile } from '../imports/expand-star-reexports.js';
import { persistSymbolIndexFileAsync } from '../persistence/persist-single-file.js';
import { getSymbolIndexParentContext, upsertSymbolIndexParentPath } from '../sqlite/symbol-index-sqlite.js';
import { withSymbolIndexSqliteLock } from '../sqlite/symbol-index-sqlite-lock.js';
import type { SymbolIndexFileEntry } from './collect-file-entries.js';
import { extractFileSymbolData } from './extract-file-symbol-data.js';
import { loadIndexedFileEntry } from './load-indexed-file-entry.js';

export async function indexOneSymbolFileForBuild(
  resolved: string,
  relPath: string,
  workspaceFiles?: ReadonlySet<string>,
): Promise<void> {
  await yieldForBridgeInteractivePriority();
  const data = await extractFileSymbolData(resolved, relPath, workspaceFiles);
  let entry: SymbolIndexFileEntry = {
    relPath,
    source: data.source,
    tags: data.tags,
    imports: data.imports,
  };

  if (data.imports.some((binding) => binding.importKind === 'star')) {
    await yieldForBridgeInteractivePriority();
    entry = await withCodeNavCacheSqlite((db) => {
      const ctx = getSymbolIndexParentContext(db, resolved);
      if (ctx == null) return entry;
      const resolveEntry = (filePath: string) => loadIndexedFileEntry(db, ctx, filePath);
      return expandStarReexportForFile(entry, resolveEntry);
    });
    entry.source = data.source;
  }

  await withSymbolIndexSqliteLock(async () => {
    await yieldForBridgeInteractivePriority();
    await persistSymbolIndexFileAsync(resolved, relPath, entry.source, entry.tags, entry.imports);
  });
}
